import React from 'react'
import './css/Common.css'
import './css/Breath.css'

const Breath = () => {
  return (
    <div className='container'>Breath</div>
  )
}

export default Breath